import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { createErrorNotification, createSuccessNotification } from '../redux/slices/notifications'

export const useClipboard = () => {
  const { t } = useTranslation()

  const dispatch = useDispatch()

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text)
      dispatch(createSuccessNotification(t('actions:copiedToClipboard')))
    } catch {
      dispatch(createErrorNotification(t('actions:copyToClipboardFailed')))
    }
  }

  return { copyToClipboard }
}
